<div class="content dark">
	<div class="form-group row">
		<label class="col-md-4">Server ID:</label>
		<div class="col-md-8">{{asset.obcu_serial_number}}</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Configuration Type:</label>
		<div class="col-md-8">
			<select [(ngModel)]="asset.asset_type_id" class="form-control">
				<option *ngFor="let config of orgConfigs" [ngValue]="config.asset_type_id">{{config.asset_type_name}}</option>
			</select>
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Asset name</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.asset_name" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Asset Serial Number</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.asset_serial_number" maxlength="32" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">SIM card ICCID</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.sim_iccid" maxlength="64" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Hardware Serial Number</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.hw_serial_number" maxlength="64" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">MAC address</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.mac_address" maxlength="64" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Board revision</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.board_revision" maxlength="64" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Gone Dark alert after x days (0 for none):</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.gonedark_days" type="number" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Suspend gone dark alerts until next active operation:</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.gonedark_suspend" type="checkbox" class="form-check-inline">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Hidden from dashboard:</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.hidden" type="checkbox" class="form-check-inline">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Override heading data:</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.override_heading" type="checkbox" class="form-check-inline">
		</div>
	</div>
	<p class="form-text">
		This setting only affects the "Flight Playback" tab. It forces the camera and aircraft model to follow the flight path, and ignore the recorded heading data.<br>
		The heading indicator below the map will still reflect the recorded heading, and will not match what is shown above.
	</p>
	<div class="form-group row">
		<div class="col-md-8 offset-md-4">
			<app-action-button [action]="UpdateAsset" [context]="this" processing="Updating..." complete="Asset updated" btnClass="btn-primary">Update Asset
			</app-action-button>
		</div>
	</div>
</div>